import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["notification", "submitButton"]

  selectAllNotifications(event) {
    this.notificationTargets.forEach(checkbox => checkbox.checked = event.target.checked)
      this.toggleSubmitButton()
    }

    toggleSubmitButton() {
      const hasSelectedNotifications = this.notificationTargets.some(checkbox => checkbox.checked)

      if (hasSelectedNotifications) {
        this.submitButtonTarget.classList.remove('hidden')
      } else {
        this.submitButtonTarget.classList.add('hidden')
    }
  }
}
